(function () {
  if (window.__kyoraPT) return; window.__kyoraPT = 1;
  var KEY = 'kyora-nav', root = document.documentElement, NS = 'http://www.w3.org/2000/svg';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var stage, svg, flat, flap, grad, foldShade;
  function el(n, a) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); return e; }
  function make() {
    stage = document.createElement('div');
    stage.style.cssText = 'position:fixed;inset:0;z-index:200;pointer-events:auto;overflow:hidden';
    svg = el('svg', { width: '100%', height: '100%', style: 'display:block;overflow:visible' });
    var defs = el('defs', {});
    grad = el('linearGradient', { id: 'kn-g', gradientUnits: 'userSpaceOnUse' });
    [['0', '#d9e0e8'], ['.18', '#eef2f6'], ['1', '#fbfcfd']].forEach(function (s) { grad.appendChild(el('stop', { offset: s[0], 'stop-color': s[1] })); });
    foldShade = el('linearGradient', { id: 'kn-s', gradientUnits: 'userSpaceOnUse' });
    [['0', 'rgba(18,32,56,0)'], ['1', 'rgba(18,32,56,.16)']].forEach(function (s) { foldShade.appendChild(el('stop', { offset: s[0], 'stop-color': s[1] })); });
    var f = el('filter', { id: 'kn-f', x: '-20%', y: '-20%', width: '140%', height: '140%' });
    f.appendChild(el('feDropShadow', { dx: '-6', dy: '-6', stdDeviation: '14', 'flood-color': '#122038', 'flood-opacity': '.28' }));
    defs.appendChild(grad); defs.appendChild(foldShade); defs.appendChild(f); svg.appendChild(defs);
    flat = el('polygon', { fill: '#ffffff' });
    var flatShade = el('polygon', { fill: 'url(#kn-s)' }); flat.__shade = flatShade;
    flap = el('polygon', { fill: 'url(#kn-g)', filter: 'url(#kn-f)' });
    svg.appendChild(flat); svg.appendChild(flatShade); svg.appendChild(flap);
    stage.appendChild(svg); (document.body || root).appendChild(stage);
  }
  function clip(pts, s, keepLess) {
    var out = [];
    for (var i = 0; i < pts.length; i++) {
      var a = pts[i], b = pts[(i + 1) % pts.length], fa = a[0] + a[1] - s, fb = b[0] + b[1] - s;
      var ina = keepLess ? fa <= 0 : fa >= 0, inb = keepLess ? fb <= 0 : fb >= 0;
      if (ina) out.push(a);
      if (ina !== inb) { var t = fa / (fa - fb); out.push([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]); }
    }
    return out;
  }
  function str(p) { return p.map(function (q) { return q[0].toFixed(1) + ',' + q[1].toFixed(1); }).join(' '); }
  // p: 0 = page fully flat (covering), 1 = page fully turned away
  function draw(p) {
    var W = innerWidth, H = innerHeight, s = (W + H) * (1 - p) + 0.01;
    var rect = [[0, 0], [W, 0], [W, H], [0, H]];
    var flatP = clip(rect, s, true), folded = clip(rect, s, false);
    var flapP = folded.map(function (q) { return [s - q[1], s - q[0]]; });
    flat.setAttribute('points', str(flatP));
    flat.__shade.setAttribute('points', str(flatP));
    flap.setAttribute('points', str(flapP));
    flap.style.display = folded.length ? '' : 'none';
    var mx = s / 2, depth = Math.min(s, W + H - s, 900) * 0.7;
    grad.setAttribute('x1', mx); grad.setAttribute('y1', mx);
    grad.setAttribute('x2', mx - depth / 1.414); grad.setAttribute('y2', mx - depth / 1.414);
    foldShade.setAttribute('x1', mx - 260); foldShade.setAttribute('y1', mx - 260);
    foldShade.setAttribute('x2', mx); foldShade.setAttribute('y2', mx);
  }
  var ease = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  function run(from, to, dur, done) {
    var t0 = performance.now();
    (function step(now) {
      var t = Math.min(1, (now - t0) / dur);
      draw(from + (to - from) * ease(t));
      if (t < 1) requestAnimationFrame(step); else done && done();
    })(t0);
  }
  var arrived = false;
  try { arrived = sessionStorage.getItem(KEY) === '1'; sessionStorage.removeItem(KEY); } catch (e) {}
  if (arrived && !reduce) {
    make(); draw(0);
    var t0 = Date.now(), fired = false;
    var reveal = function () {
      if (fired) return; fired = true;
      setTimeout(function () {
        run(0, 1, 380, function () { stage && stage.parentNode && stage.parentNode.removeChild(stage); stage = null; });
      }, 0);
    };
    requestAnimationFrame(reveal);
  }
  var pf = {};
  function prefetch(e) {
    var a = e.target.closest && e.target.closest('a[href]'); if (!a || pf[a.href]) return;
    var h = a.getAttribute('href'); if (!h || h.charAt(0) === '#' || /^(mailto:|tel:|javascript:|https?:)/i.test(h)) return;
    pf[a.href] = 1; var l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l);
  }
  document.addEventListener('mouseover', prefetch, { passive: true });
  window.addEventListener('pageshow', function (e) { if (e.persisted && stage) { stage.parentNode && stage.parentNode.removeChild(stage); stage = null; } });
  document.addEventListener('click', function (e) {
    if (reduce || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    var h = a.getAttribute('href'); if (!h || h.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(h)) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('data-kk-open') || a.hasAttribute('data-kk-back') || a.hasAttribute('download') || a.hasAttribute('data-no-transition') || !/^\/pages\/(kasari|restaurant-menu)/.test((function(){ try { return new URL(a.href, location.href).pathname; } catch (x) { return ''; } })())) return;
    var u; try { u = new URL(a.href, location.href); } catch (x) { return; }
    if (u.origin !== location.origin) return;
    if (u.pathname === location.pathname && u.search === location.search) return;
    e.preventDefault();
    try { sessionStorage.setItem(KEY, '1'); } catch (x) {}
    location.href = a.href;
  }, true);
})();
